import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from "@angular/core";
import { FormControl } from "@angular/forms";

@Component({
  selector: "app-color-toggle",
  templateUrl: "./color-toggle.component.html",
  styleUrls: ["./color-toggle.component.scss"],
})
export class ColorSettingComponent implements OnInit, OnChanges {
  @Input() imageSrc: string = "/assets/images/text-banner.png";
  @Input() label: string = "Color";

  @Input() color: string = "#c4bfbf";
  @Output() colorChange = new EventEmitter<string>();

  @Input() leftToggle = true;
  @Output() leftToggleChange = new EventEmitter<boolean>();

  @Input() efx = false;
  @Output() efxChange = new EventEmitter<boolean>();
  @Input() supportsEfx = false;

  @Input() rightToggle = false;
  @Output() rightToggleChange = new EventEmitter<boolean>();

  colorControl!: FormControl;
  leftToggleControl!: FormControl;
  rightToggleControl!: FormControl;

  ngOnInit(): void {
    // Initialize with inputs
    this.colorControl = new FormControl(this.color);
    this.leftToggleControl = new FormControl(this.leftToggle);
    this.rightToggleControl = new FormControl(this.rightToggle);

    // Emit changes upward
    this.colorControl.valueChanges.subscribe((value) => this.colorChange.emit(value));
    this.leftToggleControl.valueChanges.subscribe((value) => this.leftToggleChange.emit(value));
    this.rightToggleControl.valueChanges.subscribe((value) => this.rightToggleChange.emit(value));
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Sync with parent changes dynamically
    if (this.colorControl) {
      if (changes.color && changes.color.currentValue !== this.colorControl.value) {
        this.colorControl.setValue(changes.color.currentValue, { emitEvent: false });
      }
      if (changes.leftToggle && changes.leftToggle.currentValue !== this.leftToggleControl.value) {
        this.leftToggleControl.setValue(changes.leftToggle.currentValue, { emitEvent: false });
      }
      if (changes.rightToggle && changes.rightToggle.currentValue !== this.rightToggleControl.value) {
        this.rightToggleControl.setValue(changes.rightToggle.currentValue, { emitEvent: false });
      }
    }
  }

  onLeftToggleClick(event: Event): void {
    if (this.supportsEfx) {
      event.preventDefault();
      event.stopPropagation();
      if (!this.leftToggle) {
        // State 1 -> State 2 (Normal)
        this.leftToggle = true;
        this.efx = false;
      } else if (!this.efx) {
        // State 2 -> State 3 (EFX)
        this.leftToggle = true;
        this.efx = true;
      } else {
        // State 3 -> State 1 (Off)
        this.leftToggle = false;
        this.efx = false;
      }
      if (this.leftToggleControl) {
        this.leftToggleControl.setValue(this.leftToggle, { emitEvent: false });
      }
      this.leftToggleChange.emit(this.leftToggle);
      this.efxChange.emit(this.efx);
    }
  }
}
